<template>
    <div class="tasks-mobile">
        <div v-click-outside="tasksRenameOk" v-if="!tasks_plus && notShowSearch">
            <input
                type="text"
                class="input-tasks-mobile z-index-100"
                required
                autofocus 
                placeholder="Название подраздела"
                v-model="tasks_plus_name"
            >
            <div class="fixed button_change_mobile_task button_change_task pointer" @click="addTaskHandle()">Добавить</div>
        </div>
        <div class="button_change_task" v-if="editOrDelTask && notShowSearch">
            <div class="button_change_mobile_task edit-task mt-5 pointer" @click="renameMobileTask()">Редактировать</div>
            <DeleteItem :taskMobile="true" @deleteItem="deleteTask()"/>
        </div>
        <div class="flex-center task-scroll" v-if="notAddNewSub && notShowSearch">
            <div class="add-task">
                <img @click="hidePlusTasks" class="ml-3" height="33.91px" src="@/assets/images/components/button-add-blue.png">
            </div>
            <div v-for="task in tasks" :key="task._id">
                <TaskMobile
                    :id="`task-mobile-id-${task._id}`"
                    :task="task"
                    :editTask="current_task && longTouchedTask && longTouchedTask._id == task._id ? longTouchedTask: themes[0]"
                    @touchstart.native="getTouchedTask(task)"
                    :handleLongTouch="handleLongTouch"
                    @click.native="selectTask(task)"
                    @renameTask="longTouchedTask = themes[0]"
                    @selectTask="selectTask(task)"
                />
            </div>
            <div v-if="!tasks.length" class="roboto-normal-18 clr-black-38 ml-6" @click="hidePlusTasks">Добавить подраздел</div>
        </div>
        <div class="addTask" v-if="!tasks_plus"></div>
        <div class="addTask" v-if="editOrDelTask"></div>
        <div class="task-body-mobile-wrap mx-6 mt-8 relative" v-if="notAddNewSub && notShowSearch && current && current_task && tasks.length">
            <TTextArea v-model="taskBodyMobile" :key="current_task._id" @pasteFile="val => addFileForTask(val)"/>
            <InputFileButton class="select-file" accept="image/*" @change="addFileForTask"/>
        </div>
        <Images v-if="notAddNewSub && notShowSearch && current && current_task" :images="imagesForTask" @deleteImage="val  => deleteFileForTask(val)"/>
        <div class="add-sub flex-center mt-7" v-if="tasks.length && notAddNewSub && notShowSearch">
            <img @click="addNewSub()" class="ml-3" height="33.91px" src="@/assets/images/components/button-add-green.png">
            <div class="roboto-normal-18 clr-black-38 ml-6" @click="addNewSub()">Добавить новую заметку</div>
        </div>
        <div class="relevant-elements-mobile d-flex" v-if="notAddNewSub && notShowSearch && tasks.length">
            <div class="add-relative flex-center ml-3 my-5" @click="SET_RELEVANT_ELEMENT(current_task)">
                <img  height="33.91px" src="@/assets/images/components/button-add-yellow.png">
                <div class="roboto-normal-18 clr-black-38 ml-6" v-if="current_task && !current_task.relatedTasks.length && !current_task.relatedSubs.length">Добавить связь</div>
            </div>
            <RelatedLinks class="ml-4" :element="current_task" :deleteElementsInTask="true"/>
        </div>
        <div class="button_change_task_double" v-if="notAddNewSub && notShowSearch && current && current_task && tasks.length">
            <DeleteItem :taskMobile="true" @deleteItem="deleteTask()"/>
        </div>
        <div class="subs-mobile pb-2 mt-6" v-if="notAddNewSub && notShowSearch">
            <SwitchActive class="mx-4 flex-center" @toggle="subsAll = !subsAll" :activeLength="subsActiveLength" :allLength="current_task && current_task.subs.length" :all="subsAll" v-show="current_task && current_task.subs.length"/>
            <div v-for="sub in subs" :key="sub._id">
                <div class="flex-center-between sub" @click="pickedSub(sub)" v-if="!renameSubName || renameSubName._id != sub._id">
                    <div class="roboto-normal-16 clr-black-38 py-3 pl-2 mr-2">{{sub.name}}</div>
                    <div class="flex-center mr-4 mt-2">
                        <v-icon class="mr-1" size="15" @click.stop="toRenameSub(sub)">mdi-lead-pencil</v-icon>
                        <img v-if="picked_sub && (sub._id == picked_sub._id) && !renameSubName" src="@/assets/images/components/arrow-down.svg">
                        <img v-else src="@/assets/images/components/arrow-up.svg">
                    </div>
                </div>
                <div v-else class="flex-center-between s">
                    <input
                        type="text"
                        class="input-subs-rename-mobile"
                        required
                        autofocus 
                        placeholder="Заголовок"
                        v-model="renameSubName.name"
                    >
                    <v-icon size="15" class="rename-sub mt-3" @click="toRenameSubName(sub)">mdi-check</v-icon>
                </div>
                <div v-if="picked_sub && (sub._id == picked_sub._id) && !renameSubName" class="sub-body-mobile-wrap relative roboto-normal-14 clr-black-38 sub-body pl-2 mt-2">
                    <TTextArea v-model="subBodyMobile" @pasteFile="val => addFileForSub(val)"/>
                    <InputFileButton ref="select_file" class="select-file" accept="image/*" @change="addFileForSub"/>
                </div>
                <Images v-if="picked_sub && (sub._id == picked_sub._id) && !renameSubName" class="ml-5" :images="imagesForSub" @deleteImage="val  => deleteFileForSub(val)"/>
                <div class="relevant-elements-mobile d-flex ml-8 mt-2" v-if="picked_sub && (sub._id == picked_sub._id) && !renameSubName">
                    <div class="add-relative flex-center ml-3" @click="SET_RELEVANT_ELEMENT(picked_sub)">
                        <img  height="33.91px" src="@/assets/images/components/button-add-yellow.png">
                        <div class="roboto-normal-18 clr-black-38 ml-2" v-if="sub && !sub.relatedTasks.length && !sub.relatedSubs.length">Добавить связь</div>
                    </div>
                    <RelatedLinks class="ml-4" :element="sub" :deleteElementsInTask="false"/>
                </div>
                <div class="flex-center-between mt-3 mb-8 mx-8" v-if="picked_sub && (sub._id == picked_sub._id) && !renameSubName">
                    <div class="span">{{sub.completed ? 'Сделать активной:' : 'Скрыть:'}} <v-icon size="20" @click="toggleCompletedSub()" class="toggler">{{sub.completed ? icons[+hover] : icons[+!hover]}}</v-icon></div>
                    <div class="button-delete-sub">
                        <DeleteItem :subMobile="true" @deleteItem="deleteSub()"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="add-sub" v-if="!notAddNewSub">
            <div class="flex-center-between buttons-complete">
                <div class="flex-center ml-n3" @click="backToTheme()">
                    <img src="@/assets/images/components/arrow-left-blue.svg">
                    <div class="roboto-normal-18 clr-blue ml-2">Назад</div>
                </div>
                <div class="roboto-normal-18 clr-blue" @click="addSubHandleMobile()">Готово</div>
            </div>
            <input
                type="text"
                class="input-subs-mobile"
                required
                autofocus 
                placeholder="Заголовок"
                v-model="subs_plus_name"
            >
            <div class="border"></div>
            <input
                type="text"
                class="input-subs-mobile body"
                required
                autofocus 
                placeholder="Введите текст заметки"
                v-model="subs_plus_body"
            >
        </div>
        <div class="search" v-if="!notShowSearch">
            <div class="flex-center mt-8" @click="toPrevPage()">
                <img class="ml-7" src="@/assets/images/components/arrow-left-blue.svg">
                <div class="roboto-normal-18 clr-blue ml-2">Назад</div>
            </div>
            <SearchMobile @toTask="notShowSearch = true"/>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import TTextArea from '../../misc/TTextArea'
import SearchMobile from '../../header/SearchMobile'
import {relevantNotices, searchNotices} from '../../../helpers'
import { debounce } from 'lodash'
import RelatedLinks from './../RelatedElements/RelatedLinks'
import DeleteItem from '../../popups/DeleteItem'
import ClickOutside from 'vue-click-outside'
import InputFileButton from '@/components/misc/InputFileButton.vue'
import TaskMobile from './TaskMobile'
import { imagesOfItems } from '@/helpers'
import Images from '../../popups/Images'
import SwitchActive from './SwitchActive.vue'
export default {
    name: 'TaskViewMobile',
    components:{
        TTextArea,
        SearchMobile,
        RelatedLinks,
        DeleteItem,
        InputFileButton,
        TaskMobile,
        Images,
        SwitchActive
    },
    data() {
        return {
            hover: false,
            icons: ['mdi-eye-off', 'mdi-eye'],
            subsAll: false,
            tasks_plus: true,
            tasks_plus_name: '',
            subs_plus_name: '',
            subs_plus_body: '',
            all: false, 
            tasksSearch:'',
            notAddNewSub: true,
            notShowSearch: true,
            editOrDelTask: false,
            touchedTask: null,
            longTouchedTask: null,
            renameSubName: null,
        }
    },
    computed:{
        ...mapGetters(["themes", "current" , "current_task", "feeds", "current_relevant_notices", "picked_sub"]),
        tasks(){
            const tasks = this.current ? this.current.tasks : []
            const filterTasks = this.tasksSearch ? tasks.filter(el => el.name.toLowerCase().includes(this.tasksSearch.toLowerCase())) : tasks
            return this.all ? tasks && filterTasks : tasks.filter(el => !el.completed && !this.current.groups.some(group => group.itemsId.some(id => id == el._id)) && !el.elder) 
        },
        subs(){
            const subs = this.current_task ? this.current_task.subs : []
            const unsorted = this.subsAll ? subs : subs.filter(el => !el.completed && !el.elder)
            return [...unsorted].sort((a,b) => (+new Date(a.updatedAt)) > (+new Date(b.updatedAt)) ? -1 : 1)
        },
        subBodyMobile: {
            get(val){
              return this.picked_sub.body
            },
            set: debounce(function(newVal) {
              this.editSub({_id: this.current._id, task_id: this.current_task._id, sub_id: this.picked_sub._id, text: newVal})
            }, 450)
        },
        taskBodyMobile: {
            get(val){
              return this.current_task ? this.current_task.body : this.current.tasks[0].body
            },
            set: debounce(function(newVal) {
                  this.editTask({_id: this.current._id, task_id: this.current_task._id, text: newVal})
            }, 450),
        },
        imagesForTask() {
            const parsingLinks = imagesOfItems(this.current_task)
            const set = imagesOfItems(this.current_task) && [...(this.current_task.blockedLinks || [])] && new Set(this.current_task.blockedLinks)
            const links = parsingLinks.filter(e => !set.has(e))
            const taskImages = this.current_task.images && this.current_task.images.map((el) => this.$root.origin + '/api' + el)
            return [...(taskImages || []), ...links]
        },
        imagesForSub() {
            const parsingLinks = imagesOfItems(this.picked_sub)
            const set = imagesOfItems(this.picked_sub) && [...(this.picked_sub.blockedLinks || [])] && new Set(this.picked_sub.blockedLinks)
            const links = parsingLinks.filter(e => !set.has(e))
            const subImages = this.picked_sub.images && this.picked_sub.images.map((el) => this.$root.origin + '/api' + el)
            return [...(subImages || []), ...links]
        },
        isLearn() {
            return this.$route.query.learn == 1
        },
        subsActiveLength() {
            return this.subs && this.subs.filter(el => !el.completed && !el.elder).length
        },
    },
    methods:{
        ...mapActions(["addTask" ,"addSub", "editTask", "delTask", "renameSub", "editSub", "delSub", "saveOrderTasks", "setRelavantNotices", "uploadFiles", "setImagesToTask", "setImagesToSub", "setBlockedLinksToTask", "setBlockedLinksToSub", "setCompletedSub"]),
        ...mapMutations(['TOGGLE_PICKED_SUB', 'SET_RELEVANT_ELEMENT']),
        selectTask(task) {
            this.setRelavantNotices(task)
            this.taskBody = task.body
            this.$router.push(`/theme/${this.current.route_name}/${task.route_name}`)
            this.pickedSub(this.picked_sub)
        },
        toggleCompletedSub() {
            this.setCompletedSub({_id: this.current._id, task_id: this.current_task._id, sub_id: this.picked_sub._id, value: !this.picked_sub.completed})
        },
        hidePlusTasks(){
            this.tasks_plus = false
        },
        async addTaskHandle(){
            await this.addTask({theme_id: this.current._id, task:{name: this.tasks_plus_name,body: ""}})
            this.tasksRenameOk()
            const tasks_id = this.tasks.map(item => item._id)
            await this.saveOrderTasks({tasks_id, _id: this.current._id})
            if(this.isLearn) {
                const lastTheme = this.themes[this.themes.length - 1]
                const lastTask = lastTheme.tasks[lastTheme.tasks.length - 1]
                this.$router.push("/theme/" + lastTheme.route_name + "/" + lastTask.route_name + "?learn=2") 
            } else {
                this.tasks.length == 1 ? this.selectTask(this.tasks[0]) : this.selectTask(this.tasks[this.tasks.length-1])
            }
            this.tasks_plus = true
        },
        tasksRenameOk(){
            if (!this.isLearn) {                
                this.tasks_plus_name
                this.tasks_plus = true
                this.tasks_plus_name = ''
            }
        },
        backToTheme() {
            this.notAddNewSub = true
            this.$root.$emit('openMobileTheme')
            this.subs_plus_name = ''
            this.subs_plus_body = ''
        },
        addSubHandleMobile() {
            this.addSub({theme_id: this.current._id, task_id: this.current_task._id, sub:{name: this.subs_plus_name, body: this.subs_plus_body}})
            this.backToTheme()
            this.subs_plus_name = ''
            this.subs_plus_body = ''
        },
        toRenameSub(sub) {
            this.renameSubName = sub
        },
        toRenameSubName(sub) {
            this.renameSub({_id: this.current._id, task_id: this.current_task._id, sub_id: sub._id, name: this.renameSubName.name}).then(() => {
              this.renameSubName = null
            })
        },
        pickedSub(sub) {
            const relNotices = relevantNotices(this.feeds, this.current_task)
            const relNoticesForSub = []
            searchNotices(relNotices, sub, relNoticesForSub)
            this.TOGGLE_PICKED_SUB({sub, relNotices, relNoticesForSub})
            // const elementSub = document.getElementById(`sub-id-${sub._id}`)
            // const elementSubScroll = elementSub.getBoundingClientRect()
            // if(elementSubScroll.height > 68) {
            //   this.$vuetify.goTo(`#sub-id-${sub._id}`, {offset: elementSubScroll.top - 64})
            // } 
        },
        addNewSub() {
            this.$root.$emit('closeMobileTheme')
            this.notAddNewSub = false
        },
        toPrevPage() {
            this.notShowSearch = true
            this.$root.$emit('openMobileTheme')
        },
        getTouchedTask (task) {
            this.touchedTask = task
        },
        handleLongTouch() {
            this.editOrDelTask = true
        },
        deleteTask() {
            const task_id = this.touchedTask ? this.touchedTask._id : this.current_task._id
            this.delTask({theme_id: this.current._id, task_id: task_id}).then(() => {
                const tasks_id = this.tasks.map(item => item._id)
                this.saveOrderTasks({tasks_id, _id: this.current._id})
                if(this.current_task._id && this.current_task._id == task_id){
                    this.$store.dispatch('setRelavantNotices', this.tasks.filter(el => !el.completed)[0])
                    this.$router.push(`/theme/${this.current.route_name}/`)
                }
            })
            this.editOrDelTask = false
        },
        renameMobileTask() {
            this.longTouchedTask = this.touchedTask
            this.editOrDelTask = false
        },
        closeButtons() {
           this.editOrDelTask = false
        },
        async deleteSub() {
            if (this.picked_sub) {
                await this.delSub({theme_id: this.current._id, task_id: this.current_task._id, sub_id: this.picked_sub._id})
                await this.pickedSub(this.picked_sub)
            }
        },
        async addFileForTask(e) {
            const file = (e.target && e.target.files[0]) || e
            if (file) {                    
                const formData = new FormData()
                formData.append('file', file)
                const filesRes = await this.uploadFiles(formData)
                await this.setImagesToTask({_id: this.current._id, task_id: this.current_task._id, images: [...(this.current_task.images || []), ...filesRes.map((el) => el.path)]})
            }
        },
        async deleteFileForTask(e) {
            if (e.includes(this.$root.origin + "/api")) {
                this.current_task.images.splice(this.current_task.images.findIndex(image => image == e.slice(24)),1)
                await this.setImagesToTask({_id: this.current._id, task_id: this.current_task._id, images: [...(this.current_task.images || [])]})
            } else {
                this.current_task.blockedLinks.push(e)
                await this.setBlockedLinksToTask({_id: this.current._id, task_id: this.current_task._id, blockedLinks: [...(this.current_task.blockedLinks || [])]})
            }
        },
        async addFileForSub(e) {
            const file = (e.target && e.target.files[0]) || e
            if (file) {                    
                const formData = new FormData()
                formData.append('file', file)
                const filesRes = await this.uploadFiles(formData)
                await this.setImagesToSub({_id: this.current._id, task_id: this.current_task._id, sub_id: this.picked_sub._id, images: [...(this.picked_sub.images || []), ...filesRes.map((el) => el.path)]})
            }
        },
        async deleteFileForSub(e) {
            if (e.includes(this.$root.origin + "/api")) {
                this.picked_sub.images.splice(this.picked_sub.images.findIndex(image => image == e.slice(24)),1)
                await this.setImagesToSub({_id: this.current._id, task_id: this.current_task._id, sub_id: this.picked_sub._id, images: [...(this.picked_sub.images || [])]})
            } else {
                this.picked_sub.blockedLinks.push(e)
                await this.setBlockedLinksToSub({_id: this.current._id, task_id: this.current_task._id, sub_id: this.picked_sub._id, blockedLinks: [...(this.picked_sub.blockedLinks || [])]})
            }
        },
    },
    async mounted() {
        this.$root.$on('closeMobileTask', () => {
            this.notShowSearch = false
        })
        this.$root.$on('selectElementMenu', () => { 
            this.toPrevPage()        
        })
        this.$root.$on('addTask', () => {
            this.tasks_plus = false
        })
        this.$root.$on('deleteMobileTheme', () => {
            if(this.themes && this.themes.length && this.themes[0].tasks && this.themes[0].tasks.length) {
                this.selectTask(this.themes[0].tasks[0])
            }
        })
    },
    updated() {
        if(this.touchedTask && (this.editOrDelTask || !this.editOrDelTask)) {
            const task = document.querySelector(`#task-mobile-id-${this.touchedTask._id}`)
            const tasks = document.querySelector(".task-scroll")
            const taskLeft = task && task.offsetLeft + task.offsetWidth;
            const tasksLeft = tasks.offsetLeft + tasks.offsetWidth;
            if (taskLeft >= tasksLeft + tasks.scrollLeft) {
                tasks.scrollLeft = (taskLeft - tasksLeft);
            } else if (taskLeft <= tasks.offsetLeft + tasks.scrollLeft) {
                tasks.scrollLeft = task && task.offsetLeft - tasks.offsetLeft;
            }
        }
    },
    directives: {
        ClickOutside
    }
}
</script>

<style lang="scss" scoped>
    .edit-task{
        width: 225px  !important;
    }
.tasks-mobile {
    height: calc(100vh - 200px);
    overflow-y: scroll;  
    .select-file{
        position: absolute;
        bottom: 0;
        right: 20px;
    }
    .button_change_task {
        position: fixed;
        margin: 170px auto 0px;
        right: 0;
        left: 0;
        display:flex;
        flex-direction:column;
        align-items: center;
        z-index: 112;
        width: 171px !important;
    }
    .button_change_task_double {
        display:flex;
        flex-direction:column;
        align-items: flex-start;
        padding-left: 16px;
        margin-bottom: 12px  !important;
    }
    .task-scroll {
        overflow-x: auto;
        overflow-y: hidden;
        -ms-overflow-style: -ms-autohiding-scrollbar;
        -webkit-overflow-scrolling: touch;
        white-space: nowrap;
        &::-webkit-scrollbar {
            display: none;
        }
    }
    .addTask{
        min-height: 100%;
        min-width: 600px;
        width: 100%;
        height: auto;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(87, 87, 87, 0.5);
        z-index: 111;
    }
    .subs-mobile {
        overflow: auto;
        .sub {
            width:85%;
            height:45px;
            margin:12px auto 0px;
            background: #FFFFFF;
            box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
            border-radius: 6px;
        }
        .rename-sub {
            right:12%;
        }
        .toggler {
            color : gray  !important;
            margin-left: 2px;
            &:hover {
                color: black !important;
            }
        }
        .sub-body {
            width:95%;
            max-height: 200px;
            overflow-y: scroll;
            overflow-x: hidden;
            margin: 0px auto;
        }
        .button-delete-sub {
            right: 0;
            left: 0;
            display:flex;
            flex-direction:column;
            align-items: center;
        }
    }
    .add-sub {
        margin-top:35px; 
        .buttons-complete {
            width: 85%;
            margin: 0 auto;
        }
        .border {
            width:85%;
            margin: 12px 7% 0;
            border: 1px solid #D6D6D6;
        }
    }
    .relevant-elements-mobile {
        align-items: center;
        overflow-x: auto;
        overflow-y: hidden;
        -ms-overflow-style: -ms-autohiding-scrollbar;
        -webkit-overflow-scrolling: touch;
        white-space: nowrap;
        &::-webkit-scrollbar {
            display: none;
        }
    }
}
</style>

<style lang="scss">
.tasks-mobile {
    .task-body-mobile-wrap {
        .t-textarea {
            max-height: 200px;
            overflow-y: scroll;
        }
    }
}
</style>